import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
} from "@mui/material";
import { TbFilterSearch } from "react-icons/tb";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { IoSearchOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";

const columns = [
  { id: "order_id", label: "ORDER ID", minWidth: 170, align: "center" },
  { id: "retailer", label: "RETAILER", minWidth: 170, align: "center" },
  { id: "wholesaler", label: "WHOLESALER", minWidth: 170, align: "center" },
  { id: "payment_type", label: "PAYMENT TYPE", minWidth: 170, align: "center" },
  {
    id: "order_type",
    label: "ORDER TYPE",
    minWidth: 170,
    align: "center",
  },
  {
    id: "order_status",
    label: "ORDER STATUS",
    minWidth: 170,
    align: "center",
  },
  // {
  //   id: "ryderfee",
  //   label: "RYDER FEE",
  //   minWidth: 170,
  //   align: "center",
  // },
  // { id: "date", label: "DATE", minWidth: 170, align: "center" },
];

function createData(
  order_id,
  retailer,
  wholesaler,
  payment_type,
  order_type,
  order_status
) {
  return {
    order_id,
    retailer,
    wholesaler,
    payment_type,
    order_type,
    order_status,
  };
}

const rows = [
  createData(
    "Order001",
    "ABC Medicine",
    "Vasavi Agency",
    "Credit Order",
    "Regular Order",
    "New Order",
    "₹100.00",
    "01/06/2025"
  ),
  createData(
    "Order002",
    "ABC Medicine",
    "Vasavi Agency",
    "Credit Order",
    "Regular Order",
    "New Order",
    "₹100.00",
    "01/06/2025"
  ),
  createData(
    "Order003",
    "ABC Medicine",
    "Vasavi Agency",
    "Credit Order",
    "Regular Order",
    "New Order",
    "₹100.00",
    "01/06/2025"
  ),
];

export function RyderOrderHistory({ id }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [ryderOrdersHistory, setRyderOrdersHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const fetchRyderOrdersHistory = async () => {
    if (!id) {
      setRyderOrdersHistory([]);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(`/admin/rider-orderhistory/${id}`);
      console.log("✅ Ryder Orders History List response:", res.data);

      if (res.data.status === "success" && Array.isArray(res.data.data)) {
        const formatted = res.data.data.map((item) => ({
          id: item.order_id,
          orderitem_id: item.orderitem_id,
          order_id: `${String(item.order_id).padStart(3, "0")}`,
          retailer: titleCase(item.retailer),
          wholesaler: titleCase(item.wholesaler),
          payment_type: titleCase(item.payment_type),
          order_type: titleCase(item.order_type) + " Order",
          order_status: titleCase(item.order_status),
        }));
        setRyderOrdersHistory(formatted);
      } else {
        setError("Failed to fetch Ryder Orders History data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Ryder Orders History data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRyderOrdersHistory();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function titleCase(str = "") {
    return str
      .replace(/_/g, " ")
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <div className="admin-top-container">
          <div className="admin-listText">List Of Orders</div>
          {/* <div>
            <select
              className="listAdmin-showRecords"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value={20}>Show No of Records</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={5000}>5000</option>
            </select>
          </div> */}
          {/* <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input type="text" placeholder="Search"></input>
            </div>
          </div> */}
          <div>{""}</div>
          <div>{""}</div>
          {/* <div className="btnFilter">
            <button onClick={handleShow}>
              <TbFilterSearch /> Filter
            </button>
          </div> */}
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : ryderOrdersHistory.length > 0 ? (
                  ryderOrdersHistory
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={`${column.id}-column tableCelldata`}
                              onClick={
                                column.id === "order_id"
                                  ? () =>
                                      navigate(
                                        `/manage-ryder-eachorder/${row.orderitem_id}`
                                      )
                                  : undefined
                              }
                              sx={{
                                cursor:
                                  column.id === "order_id"
                                    ? "pointer"
                                    : "default",
                                color:
                                  column.id === "order_id" ? "#4184D1" : "",
                              }}
                            >
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={ryderOrdersHistory.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </>
  );
}
